export const styleButtonEnum = {
  default: {
    backgroundColor: 'var(--color-primary-background)',
    textColor: 'white',
    borderColor: 'var(--color-primary-border)',
    bgHover: 'var(--color-primary-hover)',
  },

  primary: {
    backgroundColor: 'var(--color-primary-background)',
    textColor: 'white',
    borderColor: 'var(--color-primary-border)',
    bgHover: 'var(--color-primary-hover)',
  },

  secondary: {
    backgroundColor: 'var(--color-secondary-background)',
    textColor: 'white',
    borderColor: 'var(--color-secondary-border)',
    bgHover: 'var(--color-secondary-hover)',
  },

  success: {
    backgroundColor: 'var(--color-success-background)',
    textColor: 'white',
    borderColor: 'var(--color-success-border)',
    bgHover: 'var(--color-success-hover)',
  },

  error: {
    backgroundColor: 'var(--color-error-background)',
    textColor: 'white',
    borderColor: 'var(--color-error-border)',
    bgHover: 'var(--color-error-hover)',
  },

  alert: {
    backgroundColor: 'var(--color-alert-background)',
    textColor: 'white',
    borderColor: 'var(--color-alert-border)',
    bgHover: 'var(--color-alert-hover)',
  },

  inheit: {
    backgroundColor: 'var(--color-inheit-background)',
    textColor: 'white',
    borderColor: 'var(--color-inheit-border)',
    bgHover: 'var(--color-inheit-hover)',
  },
};
